module.exports = __webpack_public_path__ + "static/picwords-audio-sketch-9722adf9ac968e7ed9ee7b478cde7b0e.png";